// Окно «Причины»: открывается ссылкой с адресом #top-bar-reasons из текста верхнего бара
(function () {
    var popup = document.getElementById('top-bar-reasons');

    if (!popup) {
        return;
    }

    var closeButton = popup.querySelector('.top-bar-popup__close');
    var openedClass = 'top-bar-popup-opened';
    var trigger = null;
    var formStarted = false;

    // На мобилке лист начинается сразу под шапкой; её высота зависит от бара и прокрутки страницы
    function updateOffset() {
        var header = document.querySelector('.new_header__top-wrapper');

        if (!header) {
            return;
        }

        var bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        popup.style.setProperty('--top-bar-popup-offset', bottom + 'px');
    }

    function open(link) {
        trigger = link;
        updateOffset();
        popup.hidden = false;
        popup.scrollTop = 0;
        popup.classList.remove('is-scrolled');
        document.documentElement.classList.add(openedClass);
        closeButton.focus({ preventScroll: true });

        // Адрес страницы для письма и CRM; в остальных формах сайта поле заполняет dev.js, но не в этом окне
        popup.querySelectorAll('.form_url_dynamic').forEach(function (input) {
            input.value = window.location.href;
        });

        if (!formStarted && typeof window.lavsitInitLazyCf7 === 'function') {
            formStarted = true;
            window.lavsitInitLazyCf7(popup);
        }

        history.pushState({ lavPopup: popup.id }, '');
    }

    function close() {
        popup.hidden = true;
        document.documentElement.classList.remove(openedClass);

        if (history.state && history.state.lavPopup === popup.id) {
            history.back();
        }

        if (trigger) {
            trigger.focus({ preventScroll: true });
            trigger = null;
        }
    }

    document.addEventListener('click', function (event) {
        var link = event.target.closest('a[href="#top-bar-reasons"]');

        if (!link) {
            return;
        }

        event.preventDefault();
        open(link);
    });

    closeButton.addEventListener('click', close);

    window.addEventListener('popstate', close);

    // Клик по затемнению закрывает окно. Окно — это карточки, а на мобилке весь белый лист.
    // Нажатие должно и начаться, и закончиться снаружи: иначе выделение текста мышью до края закрыло бы окно
    var mobile = window.matchMedia('(max-width: 767px)');
    var pressedOutside = false;

    function isOutside(target) {
        return !target.closest(mobile.matches ? '.top-bar-popup__sheet' : '.top-bar-popup__card, .top-bar-popup__close');
    }

    popup.addEventListener('pointerdown', function (event) {
        pressedOutside = isOutside(event.target);
    });

    popup.addEventListener('click', function (event) {
        if (pressedOutside && isOutside(event.target)) {
            close();
        }

        pressedOutside = false;
    });

    // После отправки вместо формы показывается «Заявка успешно отправлена», заголовок блока формы не нужен
    document.addEventListener('wpcf7mailsent', function (event) {
        var formSection = popup.querySelector('.top-bar-popup__form');

        if (formSection && formSection.contains(event.target)) {
            formSection.classList.add('is-sent');
        }
    });

    // Подсказка «Узнайте больше причин» видна, пока окно не прокручено
    popup.addEventListener('scroll', function () {
        popup.classList.toggle('is-scrolled', popup.scrollTop > 0);
    }, { passive: true });
})();
